export default __webpack_public_path__ + "static/BoschSans-Regular-7bb96df200da2c232187f1eb8468cdde.woff";